import { LicenseInfo } from '@mui/x-license-pro';

export function registerMaterialUiLicense() {
    // Yes, license is supposed to be public.
    // mui.com Order #76820; October 16, 2023 under roman.gavrilov@projectcanary.com email.
    const trustwellMaterialUiProLicense = 'f1a35e1396cfdcdda67eb873f52d26dfTz03NjgyMCxFPTE3MjkxODU2NDEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';
    LicenseInfo.setLicenseKey(trustwellMaterialUiProLicense);
}
